import {Component, OnInit, ChangeDetectionStrategy, Input} from '@angular/core';

@Component({
  selector: 'app-parsed-expression-block',
  templateUrl: './parsed-expression-block.component.html',
  styleUrls: ['./parsed-expression-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ParsedExpressionBlockComponent implements OnInit {
  @Input() block: {type: string; value?: any; items: []};
  @Input() paddingLevel = 0;
  isSimple = true;
  constructor() { }

  ngOnInit() {
    if (this.block && this.block.type === 'block' && this.block.items) {
      this.isSimple = this.checkSimple(this.block.items);
    }
  }

  checkSimple(items): boolean {
    return !items.find(el => el ? ['logic', 'block'].includes(el.type) : false);
  }

}
